import * as React from 'react';

import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import ReactHtmlParser from 'react-html-parser';
import { AjaxCallHelpers } from './helpers/AjaxCallHelpers';
import { LabelAndPopover } from './components/label-and-popover';

export interface RangeState {
    dataSourceCounter: number;
    timer: any;
    showPopoverText : boolean;
}

class Range extends React.Component<FormControlProps, RangeState> {
    constructor(props: FormControlProps) {
        super(props);
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            showPopoverText: false
        };
    }

    showPopoverText = (event) => {
        event.preventDefault();
        this.setState({showPopoverText: !this.state.showPopoverText});
        return false;
    }

    unmounted : boolean = false;
    componentDidMount() {

        if (this.unmounted) {
            return;
        }
        
        AjaxCallHelpers.getRelatedData(this as any, (parseFloat(this.props.field.value) || 0).toString());
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    render() {
        const inputProperties = {
            // Input properties has everything needed to deal with manual input
            // It will load related data when a datasource is set
            ...FormControlHelpers.inputProperties(this)
        };        

        let value = parseFloat(inputProperties.value) || 0;

        let left = "50%";
        let max = this.props.formFieldDefinition.max || 0;
        let min = this.props.formFieldDefinition.min || 0;
        if (max > 0) {
            left = (value / max * 100) + "%";
        }

        const showMinValue = min != value;
        const showMaxValue = max != value;

        return (
            <>
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group" }>
                <LabelAndPopover 
                    className="form__radio-label"
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                <div className="input-group">
                    <input
                        {...inputProperties}
                        maxLength={PropertyHelpers.getMaxLength(this.props, 250)}
                        type="range"
                        min={this.props.formFieldDefinition.min || 0}
                        max={this.props.formFieldDefinition.max || 1}
                        step={this.props.formFieldDefinition.step || 1}
                        value={parseFloat(inputProperties.value) || 0}
                        className={"form-control-range " + FormStylingHelpers.getInputStyle(this)}
                    /> 
                    <div className="input-group-append form-control--is-valid-indicator">
                        <div className="input-group-text">
                            <span className="icon icon-checkmark" />
                        </div>
                    </div>
                    <div className="form-control-range__values">
                        {showMinValue && <span className="form-control-range__value-min">{this.props.formFieldDefinition.min || 0}</span>}
                        <span style={
                                {
                                    left: left
                                }
                            }className="form-control-range__value-value">{parseFloat(inputProperties.value) || 0}</span>
                        {showMaxValue && <span className="form-control-range__value-max">{this.props.formFieldDefinition.max || 0}</span>}
                    </div>
                    {FormControlHelpers.invalidFeedbackComponent(this)}
                </div>
                {this.props.formFieldDefinition.hasPopover === undefined && 
                 this.props.formFieldDefinition.explanation && 
                    this.props.formFieldDefinition.explanation !== "" ? <span className="form-control-plaintext-explanation">{ReactHtmlParser(this.props.formFieldDefinition.explanation)}</span> : null}
            </div>
            <div className={ Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group-after" + " form-group-after "}></div>
            </>
        );
    }
}

export { Range };
